import React from 'react';
import PropTypes from 'prop-types';
import HeaderDirectory from './HeaderDirectory';
import RowDirectory from './RowDirectory';
import { StyledTableWrapper } from './style';

const StationTable = ({ dataStation }) => (
  <StyledTableWrapper>
    <HeaderDirectory />
    {dataStation.map((item, i) => (
      <RowDirectory key={`row-d-${i + 1}`} dataRow={item} />
    ))}
  </StyledTableWrapper>
);

StationTable.propTypes = {
  dataStation: PropTypes.arrayOf(
    PropTypes.shape({
      order: PropTypes.string,
      pos: PropTypes.string,
      text: PropTypes.string,
      name: PropTypes.string,
      price: PropTypes.number,
      date: PropTypes.string,
      sapCode: PropTypes.string,
      providerName: PropTypes.string
    })
  )
};

export default StationTable;
